<template>
  <v-card class="pa-5">
    <v-card-title class="font-bold pa-0 pb-4" primary-title>
      <h3>
        <span>Drag & Drop to prioritize</span>
      </h3>
      <br />
      <v-spacer></v-spacer>
      <v-icon @click="$emit('closePriorityDialog')">mdi-close</v-icon>
    </v-card-title>

    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <draggable v-if="appData.phases.length > 0" v-model="appData.phases">
      <transition-group>
        <section
          class="phase-style"
          v-for="element in appData.phases"
          :key="element.id"
        >
          <span v-html="element.name"></span>
        </section>
      </transition-group>
    </draggable>
    <h3 v-else class="text-center my-5">Loading ...</h3>
    <v-btn color="primary" class="mt-5 mx-2" large @click="save">Save</v-btn>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import { UpdateData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      globalServerErrors: null
    };
  },
  props: {
    appData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    draggable
  },
  methods: {
    save() {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("priority_only", "");

      if (this.appData.phases.length > 0) {
        this.appData.phases.forEach(parent => {
          Object.keys(parent).forEach(phase => {
            if (phase == "id") {
              formData.append(`phases[]`, parent[phase]);
            }
          });
        });
      }
      UpdateData({
        reqName: `hr/application-types`,
        data: formData,
        id: this.appData.id
      })
        .then(() => {
          this.$emit("closePriorityDialog");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
